export enum ETypeSubstrat {
    Bryophytes = 1,
    HydrophytesImm = 2,
    LitieresBranchagesRacines = 3,
    PierresGalets = 4,
    Granulats = 5,
    HydrophytesEmm = 6,
    Vases = 7,
    SablesLimons = 8,
    Blocs = 9,
    AlguesMarnes = 10,
}
